<template>
  <span>
    <el-dialog title="修改支付密码" :visible.sync="oldShow" :append-to-body="true" :close-on-click-modal="false" width="500px">
      <el-form ref="vFormOld" :model="formOld" :rules="rules" :inline="true" @submit.native.prevent>
        <div style="margin-bottom: 20px; color: #909399">短信验证码将发送至{{ phone }}</div>
        <el-form-item prop="vCode" label="短信验证码： "><el-input v-model="formOld.vCode" placeholder="请输入短信验证码"></el-input></el-form-item>
        <el-form-item
          ><el-button type="primary" @click="sendCode" :disabled="vcCountdown != 0" style="width: 120px">{{
            vcCountdown != 0 ? vcCountdown + 's后再获取' : '获取验证码'
          }}</el-button></el-form-item
        >
      </el-form>
      <span slot="footer">
        <el-button plain @click="oldShow = false">取 消</el-button>
        <el-button type="primary" @click="submitOld" :loading="btnloadSubmit">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改支付密码" :visible.sync="newShow" :append-to-body="true" :close-on-click-modal="false" width="500px">
      <el-form ref="vFormNew" :model="formNew" :rules="rules" :inline="true" @submit.native.prevent>
        <el-form-item prop="oldPwd" label="旧密码：" label-width="120px"
          ><el-input v-model="formNew.oldPwd" placeholder="请输入旧密码" show-password :minlength="8" :maxlength="20" style="width: 322px"></el-input
        ></el-form-item>
        <el-form-item prop="newPwd" label="新密码：" label-width="120px"
          ><el-input
            v-model="formNew.newPwd"
            placeholder="请输入新密码，8-20位"
            show-password
            :minlength="8"
            :maxlength="20"
            style="width: 322px"
          ></el-input
        ></el-form-item>
        <el-form-item prop="newPwd2" label="确认新密码：" label-width="120px"
          ><el-input
            v-model="formNew.newPwd2"
            placeholder="请再次输入新密码"
            show-password
            :minlength="8"
            :maxlength="20"
            style="width: 322px"
          ></el-input
        ></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button plain @click="newShow = false">取 消</el-button>
        <el-button type="primary" @click="submitNew" :loading="btnloadSubmit">确 认</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { regular } from '@/configs/validate'
export default {
  props: {
    id: String,
    phone: String
  },
  data() {
    return {
      btnloadSubmit: false,
      oldShow: false,
      formOld: {},
      formNew: {},
      rules: {
        mobile: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { pattern: regular.mobile, message: regular.mobileMsg, trigger: 'blur' }
        ],
        vCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
      },
      newShow: false,
      noSend: true
    }
  },
  computed: {
    vcCountdown() {
      return this.$store.state.app.vcCountdown
    }
  },
  methods: {
    open() {
      this.formOld = {}
      this.formNew = {}
      if (this.$refs.vFormOld) this.$refs.vFormOld.clearValidate()
      if (this.$refs.vFormNew) this.$refs.vFormNew.clearValidate()
      this.oldShow = true
      this.newShow = false
      // 判断验证码
      if (this.vcCountdown) this.noSend = false
      else this.noSend = true
    },
    // 获取old验证吗
    async sendCode() {
      const res = await this.$api.SmsChangePaymentPwd()
      this.$store.dispatch('app/vcDownStart', true)
      this.noSend = false
    },
    // 下一步
    submitOld() {
      this.$refs.vFormOld.validate(async (valid) => {
        if (valid) {
          this.btnloadSubmit = true
          const res = await this.$api.SetPaymentPwdVerifySendSms(this.formOld.vCode).finally(() => {
            this.btnloadSubmit = false
          })
          this.oldShow = false
          this.$store.commit('app/clearVcCountdown')
          this.newShow = true
        }
      })
    },
    // 提交
    submitNew() {
      this.$refs.vFormNew.validate(async (valid) => {
        if (valid) {
          if (this.formNew.newPwd !== this.formNew.newPwd2) return this.$message.error('两次密码输入不一致')
          this.btnloadSubmit = true
          const res = await this.$api.SetPaymentPwd(this.formNew).finally(() => {
            this.btnloadSubmit = false
          })
          this.newShow = false
          this.$message.success('支付密码更换成功')
          this.$emit('submit')
        }
      })
    }
  }
}
</script>
